import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  BaseOneResponseInterface,
  BulkResponseDataInterface,
  GetManyResponseInterface,
} from '../../../../shared/model/interface/crud-response-interface.model';
import {
  ITagCombination,
  ITagCombinationRow,
} from '../../../../view/settings/api-automation-settings/tag-combinations/tag-combinations.model';

@Injectable({
  providedIn: 'root',
})
export class TagCombinationService {
  private readonly TAG_COMBINATIONS_URL = `${this.baseUrl}/api-automation/tag-combinations`;

  constructor(
    public http: HttpClient,
    @Inject('API_BASE_URL') private readonly baseUrl: string,
  ) {}

  public getData(params: HttpParams): Observable<GetManyResponseInterface<ITagCombination>> {
    return this.http.get<GetManyResponseInterface<ITagCombination>>(this.TAG_COMBINATIONS_URL, { params });
  }

  public getOne(recordId: number, params?: HttpParams): Observable<BaseOneResponseInterface<ITagCombination>> {
    return this.http.get<BaseOneResponseInterface<ITagCombination>>(`${this.TAG_COMBINATIONS_URL}/${recordId}`, {
      params,
    });
  }

  public addOne(record: ITagCombinationRow): Observable<BaseOneResponseInterface<ITagCombination>> {
    return this.http.post<BaseOneResponseInterface<ITagCombination>>(this.TAG_COMBINATIONS_URL, record);
  }

  public editOne(recordId: number, record: ITagCombinationRow): Observable<BaseOneResponseInterface<ITagCombination>> {
    return this.http.patch<BaseOneResponseInterface<ITagCombination>>(
      `${this.TAG_COMBINATIONS_URL}/${recordId}`,
      record,
    );
  }

  public deleteOnes(recordIds: number[]): Observable<BulkResponseDataInterface> {
    if (recordIds.length > 1) {
      const httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        body: {
          tagCombinations: recordIds,
        },
      };

      return this.http.delete<BulkResponseDataInterface>(`${this.TAG_COMBINATIONS_URL}/bulk/delete`, httpOptions);
    }

    return this.http.delete<BulkResponseDataInterface>(`${this.TAG_COMBINATIONS_URL}/${recordIds[0]}`);
  }
}
